import { Component } from '@angular/core';
import { ResetPasswordForm } from '../reset-password-form/reset-password-form';

@Component({
  selector: 'app-reset-right-container',
  imports: [ResetPasswordForm],
  templateUrl: './reset-right-container.html',
  styleUrl: './reset-right-container.scss',
})
export class ResetRightContainer {}
